import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class configArticlePages_template extends vnTemplate{

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  /*html*/`  
        <div class="w-form w-form-large">
            <div class="form-header">
                <h3 class="form-title icon i-article">Article Page config</h3>
            </div>
            <strong class="form-sub-title" style="margin-top: 2rem">General Options</strong>
            <div class="w-form-body">
                             
                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="bc" data-bind="checked: isBreadcrumbEnable">
                        <label class="form-label icon i-check" for="bc"><span>Breadcrumb Enabled</span></label>
                    </div>
                </div>

                 <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="rns" data-bind="checked: isReadNextEnable">
                        <label class="form-label icon i-check" for="rns"><span>Read Next Section Enabled</span></label>
                    </div>
                </div>
                
                <div class="form-body">
                    <div class="form-group">
                        <input type="checkbox" id="timeUpdate" data-bind="checked: isTimeUpdateEnable">
                        <label class="form-label icon i-check" for="timeUpdate"><span>Enable Same-Day Article Time Updates</span></label>
                    </div>
                </div>
              
         
                <div class="form-body">
                    <div class="form-group row">
                        <label for="siteDefaultListOrder" class="form-label">Default List Numbering</label>
                        <select name="" id="siteDefaultListOrder" data-bind="value: defaultListOrder">
                            <option value="ascending">Ascending</option>
                            <option value="descending">Descending</option>
                            <option value="none">None</option>
                        </select>
                    </div>
                </div>
                
                <div class="form-body">
                    <div class="form-group row">
                        <label for="key-takeaway" class="form-label">Key Takeaway Title</label>
                        <input type="text" data-bind="value: keyTakeawayTitle" class="input-text">
                    </div>
                </div>
             
                
                
            </div>    
            <div class="w-form-body">
                <div class="form-body full-width">
                    <strong class="form-sub-title">Social Media Options</strong>
                    <div class="w-form-body">
                        <div class="form-body">
                            <div class="form-group">
                                <input type="checkbox" id="ta" data-bind="checked: isTrueAnthemEnable">
                                <label class="form-label icon i-check" for="ta"><span>True Anthem Enabled</span></label>
                            </div>
                        </div>
                    </div>
                    
                    <table class="list-action social-media">
                        <thead>
                            <tr>
                                <th></th>
                                <th><span>ARTICLE HEADER</span></th>
                                <th><span>ARTICLE FOOTER</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td class="align-center">
                                    <button data-bind="event: {click: toggleSelectAll('share_links_top', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="event: {click: toggleSelectAll('share_links_top', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="event: {click: toggleSelectAll('share_links_bottom', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="event: {click: toggleSelectAll('share_links_bottom', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody data-bind="foreach: article_social_share_links">
                            <tr> 
                                <td><span class="form-label" data-bind="text: $data.type, css: $data.iconClass"></span></td>
                                <td class="align-center">
                                    <div>
                                        <input type="checkbox" data-bind="checked: $data.enabled.top, attr: {id: 'article_social_share_links_top_' + $index()}">
                                        <label class="form-label icon i-check" data-bind="attr: {for: 'article_social_share_links_top_' + $index()}"><span>Enabled</span></label>
                                    </div>
                                </td>
                                <td class="align-center">
                                    <div>
                                        <input type="checkbox" data-bind="checked: $data.enabled.bottom, attr: {id: 'article_social_share_links_bottom_' + $index()}">
                                        <label class="form-label icon i-check" data-bind="attr: {for: 'article_social_share_links_bottom_' + $index()}"><span>Enabled</span></label>
                                    </div>
                                </td>
                            </tr>  
                        </tbody>
                    </table>
                </div>
            </div>
            
            <div class="form-footer">
                <button data-bind="event: {click: onClickCancelArticleSocialMedia}" class="btn " type="button">Cancel</button>
                <button data-bind="event: {click: onClickSaveArticleSocialMedia}" class="btn highlight" type="button">Save</button>
            </div>
          
        </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "configArticlePages_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let self = this;

        return  {
            article_social_share_links: ko.observableArray([]),
            isBreadcrumbEnable: ko.observable(),
            isTrueAnthemEnable: ko.observable(false),
            isReadNextEnable: ko.observable(false),
            isTimeUpdateEnable: ko.observable(false),
            defaultListOrder: ko.observable(""),
            keyTakeawayTitle: ko.observable(""),
            additionalCreditEnabled: ko.observable(false),
            onClickCancelArticleSocialMedia: function () {
                self.onClickCancelArticleSocialMedia()
            },
            onClickSaveArticleSocialMedia: function () {
                self.onClickSaveArticleSocialMedia()
            },
            toggleSelectAll: function (col, checked){
                self.toggleSelectAll(col,checked)
            }
        };
    }

    public set_article_social_share_links(obj) {
        this.getTemplateViewModel().article_social_share_links(obj)
    }

    public set_isBreadcrumbEnable(bool) {
        this.getTemplateViewModel().isBreadcrumbEnable(bool)
    }

    public set_isTrueAnthemEnable(bool) {
        this.getTemplateViewModel().isTrueAnthemEnable(bool)
    }

    public set_isReadNextEnable(bool) {
        this.getTemplateViewModel().isReadNextEnable(bool)
    }

    public set_additionalCreditEnabled(bool) {
        this.getTemplateViewModel().additionalCreditEnabled(bool)
    }

    public set_isTimeUpdateEnable(bool) {
        this.getTemplateViewModel().isTimeUpdateEnable(bool)
    }

    public set_defaultListOrder(obj) {
        this.getTemplateViewModel().defaultListOrder(obj);
    }

    public set_keyTakeawayTitle(title) {
        this.getTemplateViewModel().keyTakeawayTitle(title);
    }

    protected onClickSaveArticleSocialMedia(): any {

        let articlePagesSettings = {
            'social_share_links': this.getTemplateViewModel().article_social_share_links(),
            'isBreadcrumbEnable': this.getTemplateViewModel().isBreadcrumbEnable(),
            'isTrueAnthemEnable': this.getTemplateViewModel().isTrueAnthemEnable(),
            'isReadNextEnable': this.getTemplateViewModel().isReadNextEnable(),
            'additionalCreditEnabled': this.getTemplateViewModel().additionalCreditEnabled(),
            'isTimeUpdateEnable': this.getTemplateViewModel().isTimeUpdateEnable(),
            'defaultListOrder': this.getTemplateViewModel().defaultListOrder,
            'keyTakeawayTitle': this.getTemplateViewModel().keyTakeawayTitle

        }
        this.caller.saveData(articlePagesSettings, 'article_pages_settings')
    }

    protected onClickCancelArticleSocialMedia(): any {
        this.caller.cancelArticleSocialMedia()
    }

    protected toggleSelectAll(col, checked){
        let temp = this.getTemplateViewModel().article_social_share_links();
        if(col == "share_links_top"){
            for(let e of temp){
                e.enabled.top = checked
            }
        }
        else if(col == "share_links_bottom"){
            for(let e of temp){
                e.enabled.bottom = checked
            }
        }
        this.getTemplateViewModel().article_social_share_links([])
        this.getTemplateViewModel().article_social_share_links(temp)

    }


}


// WEBPACK FOOTER //
// ./js/components/templates/configArticlePages_template.ts